"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useListenOrderStatusChange = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const operators_1 = require("rxjs/operators");
const utils_1 = require("../utils");
const common_business_1 = require("@pionex-web-kit/common-business");
/**
 * 监听仓位状态变化
 * NOTE:会有冗余的回调，因为使用时才会开始缓存仓位id和状态，未缓存到的订单只要接受到推送就会算一次变化
 *
 * @param status
 * @param base
 * @param quote
 * @param listener
 * @param customGenerateKey 可以自定义缓存的条件
 *
 */
function useListenOrderStatusChange({ status, base, quote }, listener = defaultListener, customGenerateKey = defaultGenerateKey) {
    const cacheSet = (0, react_1.useRef)();
    // 缓存已经接受过的订单+状态
    const addCache = (0, react_1.useCallback)((k) => {
        var _a;
        if (!cacheSet.current) {
            cacheSet.current = new Set();
        }
        (_a = cacheSet.current) === null || _a === void 0 ? void 0 : _a.add(k);
    }, []);
    const reaListener = (0, common_business_1.usePersistFn)(listener);
    const realGenerateKey = (0, common_business_1.usePersistFn)(customGenerateKey);
    (0, react_1.useEffect)(() => {
        // 监听 wss
        const ssOb$ = (0, trade_utils_lib_1.getTradeDependencyInstance)().getAccountWebSocket().getAllDataObservable();
        const subscription = ssOb$
            .pipe((0, operators_1.filter)((wssRes) => {
            var _a, _b, _c;
            const wssData = wssRes === null || wssRes === void 0 ? void 0 : wssRes.data;
            if (!wssData) {
                return false;
            }
            const isFutureLiteBu = (wssRes === null || wssRes === void 0 ? void 0 : wssRes.channel) === "bu_order" && (wssData === null || wssData === void 0 ? void 0 : wssData.bu_order_type) === "futures_lite";
            if (!isFutureLiteBu) {
                return false;
            }
            const k = realGenerateKey(wssData);
            if ((_a = cacheSet.current) === null || _a === void 0 ? void 0 : _a.has(k)) {
                // 当前订单，的当前状态已经通知过
                return false;
            }
            if (!!status && !status.includes(wssData.status)) {
                // 不传status全部监听
                return false;
            }
            const portfolio = ((_c = (_b = wssData.bu_order_data) === null || _b === void 0 ? void 0 : _b.portfolio) === null || _c === void 0 ? void 0 : _c[0]) || {};
            if (base && base !== portfolio.base) {
                // 和监听的base不匹配
                return false;
            }
            if (quote && quote !== wssData.quote) {
                // 和监听的quote不匹配
                return false;
            }
            return true;
        }), (0, operators_1.tap)((res) => addCache(realGenerateKey(res === null || res === void 0 ? void 0 : res.data))), (0, operators_1.map)((res) => utils_1.SimpleFuturesUtils.transferWSSOrderAPIToUI(res.data)), (0, operators_1.throttleTime)(500, undefined, { leading: false, trailing: true }))
            .subscribe({
            next: reaListener,
            error: () => { },
        });
        return () => {
            subscription.unsubscribe();
        };
    }, [addCache, base, realGenerateKey, reaListener, quote, status]);
}
exports.useListenOrderStatusChange = useListenOrderStatusChange;
function defaultGenerateKey(wssData) {
    return `${wssData.bu_order_id}|${wssData.status}`;
}
function defaultListener() { }
